import { StyleRulesCallback } from '@material-ui/core';

const styles: StyleRulesCallback = () => ({

});

export default styles;
